/** Contains type alias and definitions related to Galaxy API models. */
/**
 * Returns true if the given entry is a top level HDCA and false for sub-collections.
 */
export function isHDCA(entry) {
    return (entry !== undefined && "history_content_type" in entry && entry.history_content_type === "dataset_collection");
}
/**
 * Returns true if the given element of a collection is a DatasetCollection.
 */
export function isCollectionElement(element) {
    return element.element_type === "dataset_collection";
}
